/**
 * La borne d'équipements par chantier, vue du poseur (lot L4).
 *
 * Le serveur refuse au-delà de 30 équipements par envoi : il interroge le fabricant pour
 * chacun, sur un quota partagé avec la préproduction. Le refus arrivait APRÈS la
 * signature du client ; l'écran bloque donc dès l'étape des équipements, avec le MÊME
 * texte que le serveur (`verification_identifiant.MESSAGE_TROP_D_EQUIPEMENTS`), pour que
 * le client ne signe jamais un dossier qui serait refusé. Le poseur n'a pas accès à la
 * fiche du client : le texte dit qui ajoute la suite.
 */
export const EQUIPEMENTS_PAR_CHANTIER_MAX = 30;
export const MESSAGE_TROP_D_EQUIPEMENTS =
  `${EQUIPEMENTS_PAR_CHANTIER_MAX} équipements au plus par chantier : au-delà, votre administrateur les ajoute depuis Flexcore.`;

/** Le nombre d'actifs que l'envoi produira : un par équipement, un par radiateur posé. */
export function compterEquipements(enabledEquipements) {
  return (enabledEquipements || []).reduce(
    (total, [type, v]) => total + (type === 'Radiateur' ? ((v && v.unites) || []).length : 1), 0);
}

/** Vrai si l'envoi serait refusé : l'étape des équipements ne laisse pas continuer. */
export const depasseLaBorne = (enabledEquipements) =>
  compterEquipements(enabledEquipements) > EQUIPEMENTS_PAR_CHANTIER_MAX;
